import Cookies from "universal-cookie";
import { getLocation } from "utility/LocationUtils";
import { navigate } from "utility/NavigationService";

const cookies = new Cookies(null, { path: "/" });

export const revokeAccountAccess = (routeToLogin: boolean = false): void => {

    cookies.remove("token");
    cookies.remove("csrftoken");
    cookies.remove("role");
    cookies.remove("user");

    if (routeToLogin) {
        let location = getLocation(document.URL);
        if (!location?.pathname || location.pathname.toLowerCase() !== "/login") {
            void navigate("/login/");
        }
    }
};

export const grantAccountAccess = (accessToken: string, user: any, role: any, isSecure: boolean): void => {

    cookies.set(
        "token",
        accessToken,
        {
            maxAge: 3600,  // 1 hour
            path: "/",
            sameSite: isSecure ? "none" : false,
            secure: isSecure
        }
    );

    cookies.set(
        "user",
        user,
        {
            maxAge: 3600,  // 1 hour
            path: "/",
            sameSite: isSecure ? "none" : false,
            secure: isSecure
        }
    );

    cookies.set(
        "role",
        role,
        {
            maxAge: 3600,  // 1 hour
            path: "/",
            sameSite: isSecure ? "none" : false,
            secure: isSecure
        }
    );
};

export const getAuthToken = (): string => {
    return cookies.get("token");
};

export const isLoggedIn = (): boolean => {
    return getAuthToken() !== undefined;
};
